export default {
    methods: {
        goToHarmony(slug){
            const harmonyUrl = `${window.location.origin}/${slug}`;
            window.open(harmonyUrl, '_black');
        }
    }
}